import {DeleteModalService} from './../../services/delete-modal.service';
import {DeleteModalComponent} from './../../../shared/delete-modal/delete-modal.component';
import {AntennasModalComponent} from './../../../shared/antennas-modal/antennas-modal.component';
import {MasterService} from './../../services/master.service';
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PaginationInstance} from 'ngx-pagination';
import {CommonAlertService} from "../../../services/common-alert.service";

@Component({
  selector: 'app-antennas',
  templateUrl: './antennas.component.html',
  styleUrls: ['./antennas.component.scss']
})
export class AntennasComponent implements OnInit {

  public antennas: any;
  public filter: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By Name';


  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;

  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;

  constructor(public masterservice: MasterService, public dialog: MatDialog, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService) { }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.antennas.view'] == 1 || roles['more.antennas.add'] == 1 || roles['more.antennas.edit'] == 1 || roles['more.antennas.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.antennas.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.antennas.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.antennas.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getAntennasData();
  }

  getAntennasData() {

    this.masterservice.getIndex('/antennas/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.antennas = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;
      const newData = {
        name: '',
        number: ''
      };
      if (this.antennas.length < this.per_page) {
        for (let i = 0; i < this.itemToBePushed; i++) {
          this.antennas.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });
  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Name';
          break;
        case '1':
          this.placeHolder = 'Search By Number';
          break;
        default:
          this.placeHolder = 'Search By Name';
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AntennasModalComponent, {
      minWidth: '30vw',
      minHeight: '20vh',
      disableClose: true
    }).afterClosed().subscribe(() => this.getAntennasData());
  }


  editDialog(i) {
    const editId = this.antennas[i].id;
    const encID = this.antennas[i].enc_id;
    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(AntennasModalComponent, {
        minWidth: '30vw',
        minHeight: '20vh',
        disableClose: true,
        data: {
          edit: {
            editID: editId,
            encryId: encID
          }
        }
      }).afterClosed().subscribe(() => this.getAntennasData());
    }
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  doSearch(): void {

    if (this.searchBy != null) {
      switch (this.searchBy) {
        case '0':
          Object.assign(this.filter, {search: { type: 'str', field: 'name', text: this.searchTxt}});
          break;
        case '1':
          Object.assign(this.filter, {search: { type: 'int', field: 'number', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: { type: 'str', field: 'name', text: this.searchTxt}});
      }
    }
    this.getAntennasData();
  }

  doRefresh(): void {
    this.searchTxt = null;
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getAntennasData();
  }

  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getAntennasData();
  }

  deleteDialog(i): void {
    this.deleteModalService.openModal({
      token: localStorage.getItem('token'),
      id: this.antennas[i].id,
      encId: this.antennas[i].enc_id,
      deleteUrl: '/antennas/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.getAntennasData();
    });
  }

}

